import { render, staticRenderFns } from "./ClientDownloadBox.vue?vue&type=template&id=78d8b03b&scoped=true"
import script from "./ClientDownloadBox.vue?vue&type=script&lang=js"
export * from "./ClientDownloadBox.vue?vue&type=script&lang=js"
import style0 from "./ClientDownloadBox.vue?vue&type=style&index=0&id=78d8b03b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d8b03b",
  null
  
)

export default component.exports